import React from 'react';
import ColumnHeader, { SortType } from '../../../../ColumnHeader';

import styles from '../../../../../pages/ClubProfiles/club.scss';
import { getPlayerListViewColumnGrid } from '../../../../../utils';
import { ratingTypes } from '../../../../../utils/constants';

const SortParams = {
    PLAYER: 'name',
    SINGLES: 'singlesRating',
    DOUBLES: 'doublesRating',
    COLLEGE_YEAR: 'playerCollegeDetails',
    HIGH_SCHOOL_YEAR: 'playerHighSchoolDetails',
};

const RosterHeader = (props) => {
    const {
        rosterTabState,
        clubTierType,
        isAdminOrOwner,
        updateRosterTabState,
        showTennisRatings = true,
        showPickleBallRatings = false,
    } = props;

    const { rosterSortParam, rosterSortType } = rosterTabState;
    const isCollegeTierType = clubTierType?.isCollege;
    const schoolYearParam = isCollegeTierType ? SortParams.COLLEGE_YEAR : SortParams.HIGH_SCHOOL_YEAR;

    const gridLayout = getPlayerListViewColumnGrid({
        hideRatings: false,
        showTennisRatings,
        showPickleBallRatings,
        isCollegeTierType,
        displayYear: true,
    }).join(' ');

    const handleOnColumnClick = (sortParam, sortType) => {
        let newSortParam;
        switch (sortParam) {
            case SortParams.PLAYER:
                newSortParam = SortParams.PLAYER;
                break;
            case SortParams.SINGLES:
                newSortParam = SortParams.SINGLES;
                break;
            case SortParams.DOUBLES:
                newSortParam = SortParams.DOUBLES;
                break;
            case SortParams.COLLEGE_YEAR:
                newSortParam = SortParams.COLLEGE_YEAR;
                break;
            case SortParams.HIGH_SCHOOL_YEAR:
                newSortParam = SortParams.HIGH_SCHOOL_YEAR;
                break;
            default:
                newSortParam = rosterTabState.rosterSortParam;
        }

        rosterTabState.rosterSortParam = newSortParam;
        rosterTabState.rosterSortType = sortType;
        updateRosterTabState(rosterTabState);
    };

    return (
        <div className={`${styles.playersHeader} d-none d-md-flex`}>
            <div className="flex-grow">
                <div className="row">
                    <div className={`col-md-5 ${styles.playerHeaderColumn}`}>
                        <ColumnHeader
                            isSortable
                            columnName="Player"
                            isSelected={rosterSortParam === SortParams.PLAYER}
                            sortType={rosterSortType}
                            initialSort={SortType.ASC}
                            onClick={(sortType) => handleOnColumnClick(SortParams.PLAYER, sortType)}
                        />
                    </div>
                    <div className="col-md-7">
                        <div className="d-grid w-100" style={{ gridTemplateColumns: gridLayout }}>
                            <div className={`${styles.playerHeaderColumn}`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Singles"
                                    isSelected={rosterSortParam === SortParams.SINGLES}
                                    sortType={rosterSortType}
                                    onClick={(sortType) => handleOnColumnClick(SortParams.SINGLES, sortType)}
                                />
                            </div>
                            <div className={`${styles.playerHeaderColumn}`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Doubles"
                                    isSelected={rosterSortParam === SortParams.DOUBLES}
                                    sortType={rosterSortType}
                                    onClick={(sortType) => handleOnColumnClick(SortParams.DOUBLES, sortType)}
                                />
                            </div>
                            {showPickleBallRatings && (
                                <>
                                    <div className={`${styles.playerHeaderColumn}`}>
                                        <ColumnHeader
                                            isSortable={false}
                                            columnName={`${ratingTypes.pickleball}-S`}
                                        />
                                    </div>
                                    <div className={`${styles.playerHeaderColumn}`}>
                                        <ColumnHeader
                                            isSortable={false}
                                            columnName={`${ratingTypes.pickleball}-D`}
                                        />
                                    </div>
                                </>
                            )}
                            <div className={`${styles.playerHeaderColumn}`}>
                                <ColumnHeader
                                    isSortable
                                    columnName="Year"
                                    isSelected={rosterSortParam === schoolYearParam}
                                    sortType={rosterSortType}
                                    onClick={(sortType) => handleOnColumnClick(schoolYearParam, sortType)}
                                />
                            </div>
                            {isCollegeTierType && (
                                <div className={`${styles.playerHeaderColumn}`}>
                                    <ColumnHeader className="jcc" columnName="Paid Hit" />
                                </div>
                            )}

                        </div>
                    </div>

                </div>
            </div>
            <div className="shift-left">
                {isAdminOrOwner && (
                    <div className="width-25" />
                )}
            </div>
            <div className="bookmark" />
        </div>
    );
};

export default RosterHeader;
